<template>
    <v-container fluid tag="section" class="mt-4 bg-white border rounded shadow">
        <v-row justify="center">
            <h3 class="text-center">LISTA DE EMPLEADOS </h3><br>
            <h3 class="text-center">CUATRIMESTRE : {{ dato_cuatrimestre.no_cuatrimestre }} DEL AÑO {{ dato_cuatrimestre.anio }}</h3><br>
            <h4 class="text-center">FECHA INICIO EVALUACIÓN : {{ dato_cuatrimestre.fecha_inicio_captura }} FECHA FIN EVALUACIÓN {{ dato_cuatrimestre.fecha_fin_captura }}</h4><br>
        </v-row>
        <v-row justify="center">
            <v-alert class="text-center" type="success" icon="mdi-alert-circle-outline">
                <ul style="list-style-type: disc; padding-left: 20px; text-align: justify;">
                    
                        En este módulo podrá evaluar a los empleados que se le hayan asignado en el proceso de cuatrimestre activo. Después de que termine de evaluar el títular de su unidad administrativa debe dar el visto bueno y terminar el proceso para que se puedan generar los acuses correspondientes.
                        <br><br>
                        Si usted es titular de su unidad administrativa y desea terminar el proceso y generar los acuses correspondientes, debe cerrar sesión de esta cuenta y volver a iniciar sesión con su cuenta normal con la que accede para consultar sus timbrados de nómina (cfdi). Después de ingresar se debe dirigir al módulo de “Admin Cuatrimestre”, seleccionar el año del cuatrimestre que desea consultar y por último seleccionar el periodo del cuatrimestre para que se le despliegue la información correspondiente al cuatrimestre seleccionado.
                        <br><br>
                        Si usted es un evaluador y no tiene un titular asignado a su unidad administrativa entonces debe solicitar al área de “DEPARTAMENTO DE CONTROL Y EVALUACIÓN DE DESEMPEÑO DE PERSONAL” para que le activen los permisos para que pueda terminar el proceso sin la necesidad de depender de la validación del visto bueno de un titular. Una vez que se le hayan activado los permisos en el sistema debe cerrar sesión y voler a inicar y así usted podrá terminar el proceso y generar los acuses correspondientes.
                    
                </ul>
            </v-alert>
        </v-row>
        <v-row justify="center">
            <v-row v-if="mostrar_tabla_empleado">
                <!--  -->
                <v-simple-table>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <!-- <th style="font-weight: bold;" COLSPAN="4" class="text-center"> <h3>TOTAL INGRESOS {{ anio }}</h3>  </th> -->
                            </tr>
                            <tr>
                                <th class="text-center" style="font-weight: bold;">
                                    <h3>Total a evaluar</h3>
                                </th>
                                <th class="text-center" style="font-weight: bold;">
                                    <h3>Total enviados</h3>
                                </th>
                                <th class="text-center" style="font-weight: bold;">
                                    <h3>Total guardados</h3>
                                </th>

                                <th class="text-center" style="font-weight: bold;">
                                    <h3>Por evaluar</h3>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="text-center" style="font-weight: bold;" >
                                    <h3>{{informacion_evaluacion.total_a_evaluar}}</h3> 
                                </td>

                                <td class="text-center" style="font-weight: bold;" >
                                    <h3>{{informacion_evaluacion.total_enviados}}</h3> 
                                </td>

                                <td class="text-center" style="font-weight: bold;" >
                                    <h3>{{informacion_evaluacion.total_guardados}}</h3> 
                                </td>

                                <td class="text-center" style="font-weight: bold;" >
                                    <h3>{{informacion_evaluacion.restantes}}</h3> 
                                </td>
                                
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                <!--  -->
            </v-row>
            <br>
            <!--  -->
            <v-row justify="center" v-if="mostrar_tabla_empleado"> 
                <v-col class="d-flex" cols="12" sm="4">
                    <label>ESTADO EVALUACIÓN</label><br>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                    <label>ÁREA</label><br>
                </v-col>
            </v-row>
            <!--  -->
            <v-row justify="center" v-if="mostrar_tabla_empleado"> 
                <v-col class="d-flex" cols="12" sm="4"> 
                    <v-select color="blue-grey lighten-4" solo item-color="blue-grey lighten-4" :menu-props="{ top: true, offsetY: false }" v-model="tipo_filtro" :items="tipos_filtro" item-text="descripcion"
                        item-value="id" label="ESTADO EVALUACIÓN" @change="load_empleados_a_evaluar">
                    </v-select>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                    <v-select color="blue-grey lighten-4" solo item-color="blue-grey lighten-4" :menu-props="{ top: true, offsetY: false }" v-model="id_estructura_organizacional" :items="areas_array" item-text="nombre"
                        item-value="id" label="ÁREA" @change="load_empleados_a_evaluar">
                    </v-select>
                </v-col>
                <v-col class="d-flex" cols="12" sm="4" >
                    <v-btn   small color="#e70c0e" @click="generarAcuse()" v-if="(informacion_evaluacion.total_a_evaluar==informacion_evaluacion.total_enviados) && (dato_cuatrimestre.estatus == 0 || datos_evaluador.role_cuatrimestre == 2)">
                        <v-icon>fa fa-file-pdf-o</v-icon> <span> DESCARGAR ACUSE</span>
                    </v-btn>

                    <v-btn   small color="#e70c0e" @click="generarReporteDiasEconomicos()" v-if="(informacion_evaluacion.total_a_evaluar==informacion_evaluacion.total_enviados) && dato_cuatrimestre.estatus == 0">
                        <v-icon>fa fa-file-pdf-o</v-icon> <span> REPORTE DÍAS EXTRAORDINARIOS</span>
                    </v-btn> 
                     
                </v-col> 
                  
            </v-row>
            <!--  -->
            <v-row v-if="mostrar_tabla_empleado">  
                <v-col class="d-flex" cols="12" sm="4" > 
                    <div v-if="informacion_evaluacion.restantes == 0 && informacion_evaluacion.total_a_evaluar!=informacion_evaluacion.total_enviados && datos_evaluador.role_cuatrimestre == 2">
                        <v-btn   small color="#e70c0e" @click="terminar_proceso_enviado()">
                            <v-icon>fa fa-file-pdf-o</v-icon> <span> TERMINAR PROCESO</span>
                        </v-btn> 
                    </div>
            </v-col> 
            </v-row>
            <v-row v-if="mostrar_tabla_empleado"> 
                <v-col v-if="showTable" cols="12" sm="12">
                    <v-client-table :data="empleados_a_evaluar" :columns="columns" :options="options">
                        <template slot="acciones" slot-scope="empleado">
                            <a type="button" @click="cambiar_vista_formulario(empleado.row)" class="dropdown-item" title="VER INFORMACIÓN DEL EMPLEADO">
                                <i class="text-success fa fa-eye"></i>
                                <span>Evaluar</span>
                            </a>
                        </template>
                        <template slot="estado_evaluacion" slot-scope="empleado">
                            <span v-if="empleado.row.estado_evaluacion =='GUARDADO' || empleado.row.estado_evaluacion =='ENVIADO'" class="text-success">
                                {{ empleado.row.estado_evaluacion }}
                            </span>
                            <span v-else class="text-success">NO EVALUADO</span>

                        </template>
                    </v-client-table>
                </v-col>
            </v-row>
            <div v-else>
                <v-container>
                    <v-row>
                        <v-col class="text-right" cols="12">
                        <v-btn @click="funcion_regresar();" class="ma-2" color="primary">Regresar</v-btn>
                        </v-col>
                    </v-row>
                    <v-form>
                        <u >
                            <FONT SIZE=5 style="text-align: center;">CEDULA DE EVALUACIÓN DEL DESEMPEÑO LABORAL</FONT>
                        </u>
                        <br>
                        <!--  -->
                        <h2>OBJETIVO</h2>
                        <P>
                            Valorar las características del personal a fin de detectar a los trabajadores que se distinguen en el desempeño de sus funciones y considerar los beneficios que se les puedan brindar de acuer al programa de estimulos y recompensas.
                        </P>

                        <!--  -->
                        <h2>INSTRUCCIONES</h2>
                        <p>
                            La calificación se realizará con la mayor objetividad e imparcialidad posible, en la inteligencia de que su manejo será de carácter confidencial.
                        </p>
                        <!--  -->
                        <p>
                            Al reverso de esta hoja encontrará una serie de factores que intervienen en el Desempeño Laboral del personal y cada uno de ellos tiene diferentes conceptos que deberán ser calificados individualmente.
                        </p>
                        <!--  -->
                        <p>
                            Se deberá analizar cada concepto y marcar la calificación de éste con una <strong> "X" </strong> en el cuadro respectivo. No marque más de una calificación por concepto o de lo contrario será anulada.
                        </p>
                        <!--  -->
                        <p>
                            No deberá hacer ninguna anotación en la columna de <strong> "PUNTOS" </strong> ni en los cuadros marcados con un <strong> "*" </strong>, Asterisco. Son para uso exclusivo de la Dirección Administrativa.
                        </p>
                        <!--  -->
                        <h2>DATOS DEL EVALUADO</h2>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field disabled v-model="datos_evaluado.nombre_completo" label="NOMBRES" required></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field disabled v-model="datos_evaluado.puesto" label="PUESTO" required></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field disabled v-model="datos_evaluado.dependencia" label="DEPENDENCIA" required></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field disabled v-model="datos_evaluado.unidad_responsable" label="DIRECCIÓN" required></v-text-field>
                            </v-col>
                            <!-- <v-col cols="12" md="4">
                                <v-text-field disabled v-model="datos_evaluado.rfc" label="RFC" required></v-text-field>
                            </v-col> -->
                            <v-col cols="12" md="4">
                                <v-text-field disabled v-model="datos_evaluado.nivel" label="NIVEL" required></v-text-field>
                            </v-col>
                        </v-row>
                        <!--  -->
                        <h2>DATOS DEL EVALUADOR</h2>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field disabled v-model="datos_evaluador.nombre_completo" label="NOMBRES" required></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field disabled v-model="datos_evaluador.puesto_trabajador" label="PUESTO" required></v-text-field>
                            </v-col>
                        </v-row>
                        <!--  -->
                        <br> <h3 class="text-center">CÉDULA DE EVALUACIÓN</h3><br>
                        <h3 class="text-center">{{ grupo_puesto_eval }}</h3><br>

                        <v-container v-for="item in datos_preguntas" :key="item.id">
                            <h3 class="text-center">{{ item.descripcion }}</h3><br>
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th style="width: 75%; text-align: left;"></th>
                                            <th v-for="item_valores in item.valores_evaluacion" :key="item_valores.id" style="width: 5%; text-align: left;">
                                                {{ item_valores.descripcion }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item_preguntas in item.preguntas" :key="item_preguntas.id" >
                                        <td>{{ item_preguntas.descripcion }}</td>

                                        <td v-for="item_valores_preguntas in item_preguntas.valores_evaluacion" :key="item_valores_preguntas.id" >
                                            <v-checkbox :disabled ='!editar' v-model="item_valores_preguntas.selected" @click="handleCheckboxChange(item_valores_preguntas, item_preguntas.valores_evaluacion)">
                                            </v-checkbox>
                                        </td>

                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-container>

                        <v-row justify="center" v-if="editar">
                            <!-- seran dos valores 1=>evaluador y 2=>administrador  -->
                           <v-col cols="12" md="auto" v-if="datos_preguntas.length >0 && datos_evaluador.role_cuatrimestre == 2">
                                <v-btn color="primary" @click="guardar_formulario_empleado('enviar')">Enviar</v-btn>
                            </v-col>
                            <v-col cols="12" md="auto" v-if="datos_preguntas.length >0">
                                <v-btn color="primary" @click="guardar_formulario_empleado('guardar')">Guardar</v-btn>
                            </v-col>
                        </v-row>
                        <v-row justify="center" v-else>
                            <v-col cols="12" md="auto">
                                <v-alert type="success" icon="mdi-alert-circle-outline">
                                    Este formulario ha sido enviado!!!
                                </v-alert>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </div>
        </v-row>
        <!-- Incluye el componente ModalEspera -->
        <ModalEspera ref="modalEspera"/>
    </v-container>

</template>
<style>
    .grupo-botones {
      display: none;
      margin-top: 10px;
    }

    .boton {
      padding: 10px 20px;
      margin-right: 5px;
    }

  </style>
<script>
import { mapState } from 'vuex'
import ModalEspera from "./ModalWait.vue";
export default {
    components: {
        ModalEspera,
    },
    data:function(){
        return {
            showTable:false,
            showAlert:false,
            showTableLiquidados:false,
            showAlertLiquidados:false,

            // datos tabla
            columns: ["no_empleado",'nivel',"ap_paterno","ap_materno", "nombre","area",'estado_evaluacion','acciones'],
             options: {
                headings: {
                    no_empleado       : '# EMPLEADO',
                    nivel             : 'NIVEL',
                    ap_paterno        : "APELLIDO PATERNO",
                    ap_materno        : "APELLIDO MATERNO",
                    nombre            : "NOMBRE",
                    area              : "ÁREA",
                    estado_evaluacion : 'ESTADO DE EVALUACIÓN',
                    acciones          : 'ACCIONES',

                },
                sortable: ['no_empleado'],
                texts: {
                    count:"",
                    filter:"Buscar:",
                    filterPlaceholder: 'Buscar...',
                    limit:"Resultados:",
                    recordsDisplay: 'Resultados',
                    page:"Página:",
                    noResults:"No hay resultados",
                    filterBy: 'Buscar...',
                    loading:'Cargando...',
                    defaultOption: 'Seleccionar {column}'
                },
                filterable: true,
                filterByColumn: false,
                resizableColumns: false,
                sendEmptyFilters :false,
                childRowTogglerFirst: true,
                showChildRowToggler: true,
                perPage: 5,
                perPageValues: [5, 10, 15, 20],
                filterable: ['no_empleado','nivel',"ap_paterno","ap_materno", "nombre","area"],
                    templates: {

                    }, filterByColumn: true,
            },
            mostrarModal: false,
            //variables
            empleados_a_evaluar    : [],
            liquidados             : [],
            mostrar_tabla_empleado : true,
            apellidoPaterno        : '',
            apellidoMaterno        : '',
            nombre                 : '',
            rfc                    : '',
            grupoPuesto            : '',
            datos_evaluador        : [],
            datos_evaluado         : [],
            datos_preguntas        : [],
            grupo_puesto_eval      : '',
            registro_evaluacion    : [],
            editar                 : true,
            dato_cuatrimestre      : [],
            areas : [],
            id_estructura_organizacional : 0,
            areas_array : [],
            tipos_filtro : [{id:0,descripcion:'TODOS'},{id:1,descripcion:'NO EVALUADOS'},{id:2,descripcion:'GUARDADOS'},{id:3,descripcion:'ENVIADOS'}],
            tipo_filtro : 0,
            informacion_evaluacion : []

        }
    },
    computed:{
        ...mapState(["user"]),
        ...mapState(["token"]),
        ...mapState(["baseUrl"])
    },
    async mounted(){
        this.datos_evaluador = JSON.parse(localStorage.getItem('user'));
        await this.load_empleados_a_evaluar();
        await this.load_datos_cuatrimestre_evaluacion();
        await this.load_areas_empleados()
        this.$NProgress.done();
        
    },
    methods:{
        async load_empleados_a_evaluar(){
            try{
                
                let response = await this.$http.get("get-empleados-cuatrimestre-a-evaluar/"+this.datos_evaluador.evaluador_id+'/'+this.tipo_filtro+'/'+this.id_estructura_organizacional+'/'+this.datos_evaluador.cuatrimestre_id);

                this.empleados_a_evaluar = response.data.data.activos;
                this.dato_cuatrimestre   = response.data.data.dato_cuatrimestre;
                if (this.empleados_a_evaluar){
                    this.showTable = true;
                }else{
                    this.showAlert = true
                }


            }catch(error){
                this.showAlert = true;
            }
        },
        cambiar_vista_formulario :function(empleado){
            this.datos_preguntas = [];
            this.registro_evaluacion = []
            this.datos_evaluado = empleado;
            this.grupo_puesto_eval = 'GRUPO '+empleado.grupo_puesto
            this.obtener_formularios_empleado();
            setTimeout(() => {
                this.mostrar_tabla_empleado = false

            }, 1000);


        },
        funcion_regresar:function(){
            this.mostrar_tabla_empleado = true;
        },

        async obtener_formularios_empleado(){
            try{
                this.editar = true;
                let response = await this.$http.get("get-formulario-cuatrimestre-empleado/"+this.datos_evaluado.grupo_puestos_id+'/'+this.datos_evaluado.id_empleado+'/'+this.datos_evaluado.cuatrimestre_id+'/'+this.datos_evaluador.evaluador_id);

                this.datos_preguntas = response.data.data.activos;
                this.registro_evaluacion = response.data.data.registro_evaluacion;

                if(this.registro_evaluacion){
                    if(this.registro_evaluacion.estados_evaluacion_id == 2){
                        this.editar =false;
                    }
                }


            }catch(error){

            }
        },

        handleCheckboxChange(item_valores,grupo_de_valores) {

            grupo_de_valores.forEach(objeto => {
                if (item_valores.id !== objeto.id) {
                    // Duplica el objeto para evitar compartir referencias
                    objeto.selected = false;
                }
            });
             return grupo_de_valores
        },

        guardar_formulario_empleado:async function(tipo_guardado){

            try{
                var mensaje = '¿Estas seguro de guardar la evaluación?'
                var mensaje_advertencia = ''
                if(tipo_guardado =='enviar'){
                    mensaje = '¿Estas seguro de enviar la evaluación?'
                    mensaje_advertencia = 'una vez enviado no se podrá editar la evaluación'
                }
                this.$swal({
                    className: "text-center",
                    title: mensaje,
                    text: mensaje_advertencia,
                    icon: "warning",
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    reverseButtons: true,
                    buttons:["Cancelar","Aceptar"],
                    }).then(async (value) => {
                        if(value){
                        this.$refs.modalEspera.mostrarModal = true;
                        let form = new FormData();
                        // form.append("tipo_nomina",this.tipoNomina);
                        var tipo_usuario = "EVALUADOR"
                        form.append("tipo_guardado",tipo_guardado);
                        form.append("datos_evaluado",JSON.stringify(this.datos_evaluado));
                        form.append("datos_preguntas",JSON.stringify(this.datos_preguntas));
                        form.append("evaluador_id",this.datos_evaluador.evaluador_id);
                        form.append("id_user",this.datos_evaluador.id_user);
                        form.append("tipo_usuario",tipo_usuario);

                        let response = await this.$http.post("guardar-formulario-cuatrimestre",form);
                        if(response.data.response){
                            this.$refs.modalEspera.mostrarModal = false;
                            await this.load_empleados_a_evaluar();
                            await this.load_datos_cuatrimestre_evaluacion();
                            this.funcion_regresar();
                            this.$toastr.success('EL FORMULARIO SE HA GUARDADO EXITOSAMENTE!!');
                        }else{
                            this.$refs.modalEspera.mostrarModal = false;
                            this.$swal({
                                title: response.data.error,
                                text: "",
                                icon: "error",
                                button:"Aceptar"
                            }).then(() => this.dialog = true);


                        }
                    }
                });
            }catch(error){
                this.$refs.modalEspera.mostrarModal = false;
                console.log(error)
            }
        },

        async load_datos_cuatrimestre_evaluacion(){
            try{ 
                let response = await this.$http.get("obtener-datos-generales-evaluacion/"+this.datos_evaluador.evaluador_id+'/'+this.dato_cuatrimestre.id);

                this.informacion_evaluacion = response.data.data;
                 
            }catch(error){
                this.showAlert = true;
            }
        },

        async load_areas_empleados(){
            try{

                let response = await this.$http.get("get-areas-empleados-cuatrimestre-a-evaluar/"+this.datos_evaluador.evaluador_id+'/'+this.dato_cuatrimestre.id);

                this.areas_array = response.data.data.activos;
                 


            }catch(error){
                this.showAlert = true;
            }
        },

        generarAcuse:function(){
             
            window.open(this.baseUrl + "cuatrimestre/descargar-acuse?evaluador_id="+this.datos_evaluador.evaluador_id+"&cuatrimestre_id="+this.dato_cuatrimestre.id+"&id_user="+this.datos_evaluador.id_user,"_blank");
        },

        generarReporteDiasEconomicos:function(){
            var tipo_reporte = "EVALUADOR"
            window.open(this.baseUrl + "cuatrimestre/reporte-dias-economicos-admin?id_empleado="+this.datos_evaluador.evaluador_id+"&cuatrimestre_id="+this.dato_cuatrimestre.id+"&tipo_reporte="+tipo_reporte+"&id_user="+this.datos_evaluador.id_user,"_blank");
        },

        terminar_proceso_enviado : function(){
            try{
                var mensaje = '¿Estas seguro de iniciar el proceso de enviado?'
                var mensaje_advertencia = ''
                
                this.$swal({
                    className: "text-center",
                    title: mensaje,
                    text: mensaje_advertencia,
                    icon: "warning",
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    reverseButtons: true,
                    buttons:["Cancelar","Aceptar"],
                    }).then(async (value) => {
                        if(value){
                        this.$refs.modalEspera.mostrarModal = true;
                        let form = new FormData();
                        // form.append("tipo_nomina",this.tipoNomina);
                        form.append("id_empleado",this.datos_evaluador.evaluador_id); 
                        form.append("cuatrimestre_id",this.dato_cuatrimestre.id);
                        form.append("id_user",this.datos_evaluador.id_user);

                        let response = await this.$http.post("actualizar-evaluados-a-enviado",form);
                        if(response.data.response){
                            this.$refs.modalEspera.mostrarModal = false;
                            await this.load_empleados_a_evaluar();
                            await this.load_datos_cuatrimestre_evaluacion();
                            this.$toastr.success('SE HA ACTUALIZADO LAS EVALUACIÓNES A ESTATUS ENVIADO!!');
                        }else{
                            this.$refs.modalEspera.mostrarModal = false;
                            this.$swal({
                                title: response.data.error,
                                text: "",
                                icon: "error",
                                button:"Aceptar"
                            }).then(() => this.dialog = true);


                        }
                    }
                });
            }catch(error){
                this.$refs.modalEspera.mostrarModal = false;
                console.log(error)
            }
        },
    }
}
</script>
